import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "react-bootstrap";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";

const NotFound = () => {
  const navigate = useNavigate();

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f5f6fa',
      padding: '2rem'
    },
    content: {
      textAlign: 'center',
      maxWidth: '600px',
      animation: 'fadeInUp 0.8s ease-out'
    },
    icon: {
      fontSize: '8rem',
      color: '#4880FF',
      marginBottom: '1.5rem',
      opacity: 0.8
    },
    title: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#000',
      marginBottom: '1rem',
      textShadow: '0 4px 8px rgba(0,0,0,0.1)'
    },
    subtitle: {
      fontSize: '1.5rem',
      color: '#64758b',
      marginBottom: '2rem',
      fontWeight: '400'
    },
    message: {
      fontSize: '1.1rem',
      color: '#64758b',
      marginBottom: '2.5rem',
      lineHeight: '1.6'
    },
    button: {
      padding: '0.75rem 2rem',
      fontSize: '1.1rem',
      fontWeight: '600',
      backgroundColor: '#4880FF',
      border: 'none',
      borderRadius: '8px',
      transition: 'all 0.3s ease',
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.5rem'
    },
    buttonHover: {
      backgroundColor: '#3d91e4',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(72, 128, 255, 0.3)'
    }
  };

  return (
    <Container fluid style={styles.container}>
      <div style={styles.content}>
        <FaExclamationTriangle style={styles.icon} />
        <h1 style={styles.title}>404</h1>
        <h2 style={styles.subtitle}>Page Not Found</h2>
        <p style={styles.message}>
          The page you're looking for doesn't exist or has been moved.
          <br />
          Let's get you back on track.
        </p>
        <Button
          style={styles.button}
          onMouseEnter={(e) => {
            Object.assign(e.target.style, styles.buttonHover);
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = styles.button.backgroundColor;
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
          onClick={() => navigate('/apps')}
        >
          <FaHome /> Go to Home
        </Button>
      </div>
    </Container>
  );
};

export default NotFound;

